import "./ExperienceSubpagesStyles.css";
import "../ComponentsIndex.css";
import React, { useState } from "react";
import Subpage from "./Subpage";
import Modal from "../Modal";

// const ExperienceSubpages = () => {
//   const headings = ["All Experiences", "Currently Working", "Part-Time"];
//   const [selectedHeading, setSelectedHeading] = useState(headings[0]);
//   const handleClick = (index) => {
//     setSelectedHeading(headings[index]);
//   };

//   const [isExpand, setIsExpand] = useState(false);
//   const handleExpand = (value) => {
//     setIsExpand(value);
//   };

//   return (
//     <div className="subpages-container component-container" id="Experience">
//       <ul className="subpage-navbar">
//         {headings.map((heading, index) => (
//           <div className="modal-overlay">
//             <li
//               key={heading}
//               onClick={() => {
//                 handleClick(index);
//                 handleExpand(true);
//               }}
//               style={
//                 selectedHeading === headings[index]
//                   ? { backgroundColor: "#eee" }
//                   : {}
//               }
//             ></li>
//             <Modal modalTitle={headings[index]} x={-2} y={0} />
//           </div>
//         ))}
//       </ul>

//       {selectedHeading === headings[0] && (
//         <Subpage heading={headings[0]} collapsed={isExpand} />
//       )}
//       {selectedHeading === headings[1] && (
//         <Subpage heading={headings[1]} collapsed={isExpand} />
//       )}
//       {selectedHeading === headings[2] && (
//         <Subpage heading={headings[2]} collapsed={isExpand} />
//       )}
//     </div>
//   );
// };

// export default ExperienceSubpages;

// CHATGPT STARTS HERE

// import { useState } from "react";
// import {
//   BsArrowLeftCircleFill,
//   BsFillArrowUpCircleFill,
//   BsFillArrowDownCircleFill,
//   BsArrowRightCircleFill,
// } from "react-icons/bs";
// import Modal from "./Modal";
// import Subpage from "./Subpage";

// Assuming SubpagesData is imported or available in the scope
// import SubpagesData from './data';

// const ExperienceSubpages = () => {
//   const filters = [
//     "All Experiences",
//     "Currently Working",
//     "Part-Time",
//     "All Experiences",
//     "Currently Working",
//     "Part-Time",
//   ];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);
//   const [isExpand, setIsExpand] = useState(false);

//   const handleFilterClick = (filter) => {
//     setSelectedFilter(filter);
//     setIsExpand(true);
//   };

//   return (
//     <div className="subpages-container component-container" id="Experience">
//       <div className="filter-buttons">
//         {filters.map((filter, index) => (
//           <button
//             key={index}
//             onClick={() => handleFilterClick(filter)}
//             style={selectedFilter === filter ? { backgroundColor: "#eee" } : {}}
//           >
//             {filter}
//           </button>
//         ))}
//       </div>
//       <Subpage heading={selectedFilter} collapsed={!isExpand} />
//     </div>
//   );
// };

// export default ExperienceSubpages;

const ExperienceSubpages = () => {
  const filters = ["All Experiences", "Currently Working", "Part-Time"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
  const [isExpand, setIsExpand] = useState(false);

  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
    setIsExpand(true);
  };

  return (
    <div className="subpages-container component-container" id="Experience">
      <div className="filter-buttons">
        {filters.map((filter, index) => (
          <button
            key={index}
            onClick={() => handleFilterClick(filter)}
            style={selectedFilter === filter ? { backgroundColor: "#eee" } : {}}
          >
            {filter}
          </button>
        ))}
      </div>
      <Subpage heading={selectedFilter} collapsed={!isExpand} />
    </div>
  );
};

export default ExperienceSubpages;

// CHATGPT ENDS HERE

// NEW WORK HERE

// import React, { useState } from "react";
// import Slider from "react-slick";
// import Subpage from "./Subpage";
// import Modal from "../Modal";
// import "./ExperienceSubpagesStyles.css";
// import "../ComponentsIndex.css";

// const ExperienceSubpages = () => {
//   const headings = ["All Experiences", "Currently Working", "Part-Time"];
//   const [selectedHeading, setSelectedHeading] = useState(headings[0]);

//   const handleClick = (index) => {
//     setSelectedHeading(headings[index]);
//   };

//   const [isExpand, setIsExpand] = useState(false);
//   const handleExpand = (value) => {
//     setIsExpand(value);
//   };

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     afterChange: (index) => {
//       handleClick(index);
//       handleExpand(true);
//     },
//   };

//   return (
//     <div className="subpages-container component-container" id="Experience">
//       <Slider {...settings} className="subpage-carousel">
//         {headings.map((heading, index) => (
//           <div key={index} className="carousel-item">
//             <h2>{heading}</h2>
//             <Modal modalTitle={heading} x={-2} y={0} />
//           </div>
//         ))}
//       </Slider>

//       {selectedHeading === headings[0] && (
//         <Subpage heading={headings[0]} collapsed={isExpand} />
//       )}
//       {selectedHeading === headings[1] && (
//         <Subpage heading={headings[1]} collapsed={isExpand} />
//       )}
//       {selectedHeading === headings[2] && (
//         <Subpage heading={headings[2]} collapsed={isExpand} />
//       )}
//     </div>
//   );
// };

// export default ExperienceSubpages;

//NEW WORK 2 STARTS HERE

// import "./ExperienceSubpagesStyles.css";
// import "../ComponentsIndex.css";
// import React, { useState } from "react";
// import Subpage from "./Subpage";
// import Modal from "../Modal";

// const ExperienceSubpages = () => {
//   const headings = ["All Experiences", "Currently Working", "Part-Time"];
//   const [selectedHeading, setSelectedHeading] = useState(headings[0]);

//   const handleClick = (index) => {
//     setSelectedHeading(headings[index]);
//     handleExpand(true); // Ensure expansion when an item is clicked
//   };

//   const handleNext = () => {
//     const currentIndex = headings.indexOf(selectedHeading);
//     const nextIndex = (currentIndex + 1) % headings.length;
//     handleClick(nextIndex);
//   };

//   const handlePrev = () => {
//     const currentIndex = headings.indexOf(selectedHeading);
//     const prevIndex = (currentIndex - 1 + headings.length) % headings.length;
//     handleClick(prevIndex);
//   };

//   const [isExpand, setIsExpand] = useState(false);
//   const handleExpand = (value) => {
//     setIsExpand(value);
//   };

//   return (
//     <div className="subpages-container component-container" id="Experience">
//       <div className="carousel-controls">
//         <div className="carousel-arrow prev" onClick={handlePrev}>
//           &lt;
//         </div>
//         <div className="carousel-arrow next" onClick={handleNext}>
//           &gt;
//         </div>
//       </div>

//       <div className="carousel-content">
//         {headings.map((heading, index) => (
//           <div
//             key={heading}
//             className={`carousel-item ${
//               selectedHeading === heading ? "active" : ""
//             }`}
//           >
//             <Modal modalTitle={heading} x={-2} y={0} />
//             {selectedHeading === heading && (
//               <Subpage heading={heading} collapsed={isExpand} />
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ExperienceSubpages;
